import { render, staticRenderFns } from "./ProductText.vue?vue&type=template&id=2eb56c58&functional=true"
import script from "./ProductText.vue?vue&type=script&lang=js"
export * from "./ProductText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports